import { Link } from "react-router-dom";

const ENTRIES = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "科幻、悬疑、剧情多元片单，按地区与年代精准筛选。",
    count: "12+ 部精选影片",
    image:
      "https://readdy.ai/api/search-image?query=cinema%20screen%20glowing%20in%20a%20dark%20theater%20with%20warm%20amber%20light%2C%20minimal%20artistic%20composition%2C%20no%20text&width=600&height=420&seq=mogu-entry-movie&orientation=landscape",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "热门剧集持续更新，剧集简介、集数与章节一览无余。",
    count: "12+ 部热播剧集",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20living%20room%20at%20night%20with%20tv%20glow%20and%20warm%20lamps%2C%20minimal%20artistic%20composition%2C%20no%20text&width=600&height=420&seq=mogu-entry-tv&orientation=landscape",
  },
  {
    to: "/category/news",
    icon: "ri-newspaper-line",
    title: "影视资讯",
    desc: "行业动态、定档消息与市场观察，第一时间掌握风向。",
    count: "8+ 条最新资讯",
    image:
      "https://readdy.ai/api/search-image?query=stack%20of%20newspapers%20and%20a%20coffee%20cup%20on%20a%20wooden%20desk%20with%20soft%20light%2C%20minimal%20artistic%20composition%2C%20no%20text&width=600&height=420&seq=mogu-entry-news&orientation=landscape",
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {ENTRIES.map((entry, index) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group relative cursor-pointer overflow-hidden rounded-lg border border-background-200 animate-fade-up"
          style={{ animationDelay: `${index * 70}ms` }}
        >
          <div className="h-56 w-full overflow-hidden bg-background-200">
            <img
              src={entry.image}
              alt={`${entry.title}分类入口`}
              title={`${entry.title} - 蘑菇MOGU2`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/55 to-primary-950/10"></div>
          <div className="absolute inset-0 flex flex-col justify-end p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className={`${entry.icon} text-xl`}></i>
            </span>
            <h3 className="mt-3 text-lg font-bold text-white">{entry.title}</h3>
            <p className="mt-1.5 line-clamp-2 text-sm text-background-200">{entry.desc}</p>
            <span className="mt-3 flex items-center gap-1 text-xs font-medium text-accent-400">
              {entry.count}
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}